import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './Components/Auth/Login';
import Sale from './Components/Sale/Sale';
import './App.css';
import CustomerPayment from './Components/Customers/CustomerPayment';
import Navbar from './Components/Navbar/Navbar';
import PreviousSale from './Components/PreviousSale/PreviousSale';
import { useTranslation } from 'react-i18next';
import CancelledSaleInvoice from './Components/PreviousSale/CancelledSaleInvoice';

function App() {
  const token = localStorage.getItem('token');
  const {i18n} = useTranslation();
  return (
    <div dir={i18n.language=="ar" || i18n.language=="ckb"?"rtl":"ltr"}>
      <BrowserRouter>
        {token && <Navbar />}
        {token ? (

          <Routes>
            <Route path="/" element={<Sale />} />
            <Route path="/customer" element={<CustomerPayment />} />
            <Route path="/previous-sale" element={<PreviousSale />} />
            <Route path="/cancelled-sale" element={<CancelledSaleInvoice />} />

            <Route path="*" element={<div>404 Not Found</div>} />
          </Routes>
        ) : (
          // If token doesn't exist, show the Login page
          <Login />
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;
